export var LOGIN_INIT = 'LOGIN_INIT';
export var LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export var LOGIN_ERROR = 'LOGIN_ERROR';
export var LOGIN_DONE = 'LOGIN_DONE';
export var GET_USER_INFO_INIT = 'GET_USER_INFO_INIT';
export var GET_USER_INFO_SUCCESS = 'GET_USER_INFO_SUCCESS';
export var GET_USER_INFO_ERROR = 'GET_USER_INFO_ERROR';
export var GET_USER_INFO_DONE = 'GET_USER_INFO_DONE';
